import { inject, Injectable } from '@angular/core';
import {
    IqEventBusBrokerHandlerOptions,
    IqEventBusBrokerService,
} from '@dat/iq-event-bus';
import {
    ActionNames,
    ReplaceComponent,
    ReplaceComponentSchema,
} from './iq-builder-state-actions-section.models';
import { IqBuilderStateStatusService } from './iq-builder-state-status.service';

@Injectable({
    providedIn: 'root',
})
export class IqBuilderStateActionsSectionService {
    private readonly _eventBroker: IqEventBusBrokerService = inject(
        IqEventBusBrokerService,
    );

    private _status: IqBuilderStateStatusService = inject(
        IqBuilderStateStatusService,
    );
    constructor() {}

    replaceComponent(payload: ReplaceComponent) {
        const validatedPayload = ReplaceComponentSchema.safeParse(payload);

        if (!validatedPayload.success) return;

        this._status.replaceComponent(
            payload.dashboardId,
            payload.sectionId,
            payload.componentId,
            payload.component,
            payload.opts,
        );
    }

    register() {
        const actions: Record<
            ActionNames,
            {
                callback: (payload?: any) => void;
                opts?: IqEventBusBrokerHandlerOptions;
            }
        > = {
            replaceComponent: {
                callback: (payload: ReplaceComponent): void => {
                    this.replaceComponent(payload);
                },
            },
            deleteComponent: {
                callback: (_payload: any): void => {
                    throw new Error('Function not implemented.');
                },
            },
            addComponent: {
                callback: (_payload: any): void => {
                    throw new Error('Function not implemented.');
                },
            },
            addComponentList: {
                callback: (_payload: any): void => {
                    throw new Error('Function not implemented.');
                },
            },
        };

        this._eventBroker.registerMap(actions);
    }
}
